import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import styles from './StudioModal.module.scss';

export interface StudioModalProps {
  open: boolean;
  title: string;
  description?: string;
  onClose: () => void;
  children: React.ReactNode;
  footer: React.ReactNode;
}

export const StudioModal: React.FC<StudioModalProps> = ({
  open,
  title,
  description,
  onClose,
  children,
  footer,
}) => {
  useEffect(() => {
    if (!open) return;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener('keydown', onKeyDown);
    };
  }, [open, onClose]);

  if (!open) return null;

  return ReactDOM.createPortal(
    <div
      className={styles.overlay}
      role="presentation"
      onMouseDown={(e) => {
        // close only when clicking the overlay (not inside content)
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div className={styles.content} role="dialog" aria-modal="true" aria-label={title}>
        <div className={styles.header}>
          <div className={styles.titleRow}>
            <h2 className={styles.title}>{title}</h2>
            <button type="button" className={styles.closeButton} onClick={onClose} aria-label="Close">
              ✕
            </button>
          </div>
          {description ? <p className={styles.description}>{description}</p> : null}
        </div>

        {children}

        <div className={styles.footer}>{footer}</div>
      </div>
    </div>,
    document.body
  );
};

